
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ResetEmailPage",
      function () {
        return require("private-next-pages/ResetEmailPage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ResetEmailPage"])
      });
    }
  